


import React, { useState } from 'react';
import MedtrustHeader from '../../Compoents/MedtrustHeader';
import MedtrustFooter from '../../Compoents/MedtrustFooter';
import ConsultationsForm from '../Contact/ContactInnerSection/ConsultationForm';

import BreadcrumbArea from '../../ShearOne/BreadcrumbArea'
import { ContactForm } from '../Contact/AppointmentForm';

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import countryJson from '../../Compoents/countries.json';

const countryArray = Object.entries(countryJson).map(
  ([code, data]) => ({
    code,
    ...data,
  })
);

export default function MedicalAppointmentForm() {
    const [formData, setFormData] = useState({
        patientName: '',
        phone: '',
        email: '',
        disease: '',
        healthIssue: '',
        reference: ''
    });
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'Free Consultations', active: true }
    ];

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isDragging, setIsDragging] = useState(false);

    const diseases = [
        'Cardiology Disease',
        'Vascular Disease',
        'Respiratory Disease',
        'Gastroenterology Disease',
        'Blood & Hematology Disease',
        'Brain Surgery',
        'Spine & Spinal Cord Surgery',
        'Stroke & Paralysis',
        'Nephrology & Urology',
        'Cancer & Oncology',
        'Eye',
        'General Surgery',
        'Dental & Maxillofacial Surgery',
        'Nose, Ear & Throat',
        'Orthopedics',
        'Traditional Chinese Medicine (TCM)',
        'Pediatric Disease',
        'Gynecological Disease',
        'Infertility & IVF',
        'Geriatrics Disease',
        'Arthritis & Joint Pain',
        'Disability due to road accidents',
        'Rehabilitation & Post-surgery Physiotherapy',
        'Endocrine, Diabetics, Obesity',
        'Target Organ Check-Up',
        'Stem Cell Therapy'
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileUpload = (files) => {
        const fileArray = Array.from(files);
        const validFormats = ['doc', 'docx', 'gif', 'pdf', 'png', 'jpg', 'jpeg', 'txt', 'xls', 'xlsx'];

        const validFiles = fileArray.filter(file => {
            const extension = file.name.split('.').pop().toLowerCase();
            return validFormats.includes(extension);
        });

        setUploadedFiles(prev => [...prev, ...validFiles]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        handleFileUpload(e.dataTransfer.files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
        if (!formData.patientName || !formData.phone || !formData.disease || uploadedFiles.length === 0) {
            alert('Please fill all required fields marked with *');
            return;
        }

        console.log('Form Data:', formData);
        console.log('Uploaded Files:', uploadedFiles);
        alert('Consultation request submitted successfully!');
    };

    const formatFileSize = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <MedtrustHeader />


            <main>

                <BreadcrumbArea
                    title="Free Consultations"
                    backgroundImage="assets/imgs/appointment/appointment.png"
                    links={breadcrumbLinks}
                />

                <ConsultationsForm />
                
                

            </main>
            <MedtrustFooter />
        </div>
    );
}





